import { EXCEL_VEHICLES } from "./excelVehicles";

export const BRAND_MODELS = {
  DACIA: ["DUSTER", "SANDERO", "SANDERO STEPWAY", "LOGAN", "JOGGER", "SPRING", "DOKKER", "LODGY"],
  FORD: ["FOCUS", "FIESTA", "MONDEO", "KUGA", "PUMA", "ECOSPORT", "C-MAX", "B-MAX", "TOURNEO COURIER", "TOURNEO CONNECT", "TRANSIT", "TRANSIT CONNECT", "RANGER", "MUSTANG"],
  FIAT: ["EGEA", "EGEA CROSS", "LINEA", "PUNTO", "PANDA", "500", "500X", "500L", "DOBLO", "FIORINO", "TIPO"],
  RENAULT: ["CLIO", "MEGANE", "MEGANE SEDAN", "SYMBOL", "CAPTUR", "KADJAR", "AUSTRAL", "TALISMAN", "FLUENCE", "LAGUNA", "TWINGO", "KANGOO", "MASTER", "TRAFIC"],
  VOLKSWAGEN: ["GOLF", "POLO", "PASSAT", "JETTA", "TIGUAN", "T-ROC", "T-CROSS", "TOUAREG", "CADDY", "TRANSPORTER", "AMAROK", "ARTEON"],
  TOYOTA: ["COROLLA", "COROLLA CROSS", "YARIS", "AURIS", "AVENSIS", "CAMRY", "C-HR", "RAV4", "HILUX", "PROACE"],
  HYUNDAI: ["I10", "I20", "ACCENT", "ACCENT BLUE", "ELANTRA", "I30", "TUCSON", "SANTA FE", "KONA", "BAYON", "H100", "STAREX"],
  OPEL: ["ASTRA", "CORSA", "INSIGNIA", "MOKKA", "CROSSLAND", "GRANDLAND", "COMBO", "VIVARO", "VECTRA"],
  PEUGEOT: ["106", "206", "207", "208", "2008", "301", "307", "308", "3008", "407", "408", "5008", "508", "PARTNER", "EXPERT", "BOXER"],
  CITROEN: ["C3", "C3 AIRCROSS", "C4", "C4 CACTUS", "C5 AIRCROSS", "BERLINGO", "JUMPY", "JUMPER", "C-ELYSEE", "NEMO"],
  HONDA: ["CIVIC", "CITY", "JAZZ", "ACCORD", "CR-V", "HR-V"],
  NISSAN: ["QASHQAI", "JUKE", "MICRA", "NOTE", "X-TRAIL", "NAVARA", "NV200", "PULSAR"],
  SKODA: ["FABIA", "OCTAVIA", "SUPERB", "KAMIQ", "KAROQ", "KODIAQ", "RAPID", "SCALA", "YETI"],
  SEAT: ["IBIZA", "LEON", "TOLEDO", "ARONA", "ATECA", "ALHAMBRA"],
  KIA: ["RIO", "CEED", "STONIC", "SPORTAGE", "SORENTO", "PICANTO", "CERATO"],
  BMW: ["1 SERIES", "2 SERIES", "3 SERIES", "4 SERIES", "5 SERIES", "X1", "X3", "X5"],
  MERCEDES: ["A SERIES", "B SERIES", "C SERIES", "CLA", "E SERIES", "GLA", "GLC", "SPRINTER", "VITO"],
  "MERCEDES-BENZ": ["A SERIES", "B SERIES", "C SERIES", "CLA", "E SERIES", "GLA", "GLC", "SPRINTER", "VITO"],
  AUDI: ["A1", "A3", "A4", "A5", "A6", "Q2", "Q3", "Q5", "TT"],
  VOLVO: ["S40", "S60", "V40", "V60", "XC40", "XC60", "XC90"],
  MITSUBISHI: ["LANCER", "ASX", "OUTLANDER", "PAJERO", "L200", "SPACE STAR", "COLT"],
  SUZUKI: ["SWIFT", "VITARA", "SX4", "S-CROSS", "JIMNY", "BALENO"],
  CHERY: ["TIGGO 7", "TIGGO 8", "OMODA 5"],
  MG: ["ZS", "HS", "MG4"],
};

const trU = (s) => (s || "").toLocaleUpperCase("tr-TR").trim();
const exModel = (brand, model) => (EXCEL_VEHICLES[trU(brand)] || {})[trU(model)];
const exBrandVals = (brand, key) => {
  const d = EXCEL_VEHICLES[trU(brand)];
  if (!d) return [];
  const s = new Set();
  Object.values(d).forEach((m) => (m[key] || []).forEach((v) => s.add(v)));
  return [...s];
};
const mergeU = (a, b) => [...new Set([...a, ...b])];
export const BRANDS = [...new Set([...Object.keys(BRAND_MODELS), ...Object.keys(EXCEL_VEHICLES)])].sort();
export function modelsFor(brand) { return mergeU(BRAND_MODELS[trU(brand)] || [], Object.keys(EXCEL_VEHICLES[trU(brand)] || {})); }

export const BRAND_ENGINES = {
  DACIA: ["1.0 SCE", "1.0 TCE", "1.2 TCE", "1.5 DCI", "1.5 BLUE DCI", "1.6 SCE"],
  FORD: ["1.0 ECOBOOST", "1.25", "1.5 TDCI", "1.6 TDCI", "1.6 TI-VCT", "1.5 ECOBLUE", "1.5 ECOBOOST", "2.0 TDCI"],
  FIAT: ["1.4 FIRE", "1.3 MULTIJET", "1.6 MULTIJET", "1.4 T-JET", "1.0 GSE", "1.5 GSE", "1.6 E-TORQ"],
  RENAULT: ["1.2 TCE", "1.0 TCE", "1.5 DCI", "1.6 DCI", "1.3 TCE", "1.6 SCE", "1.5 BLUE DCI"],
  VOLKSWAGEN: ["1.0 TSI", "1.2 TSI", "1.4 TSI", "1.5 TSI", "1.6 TDI", "2.0 TDI", "1.6 MPI"],
  TOYOTA: ["1.33", "1.4 D-4D", "1.6", "1.6 D-4D", "1.8 HYBRID", "1.5 HYBRID", "2.0"],
  HYUNDAI: ["1.0 T-GDI", "1.2 MPI", "1.4 MPI", "1.4 T-GDI", "1.6 CRDI", "1.6 GDI", "2.0 CRDI"],
  OPEL: ["1.2", "1.4", "1.4 T", "1.5 D", "1.6 CDTI", "1.6 T"],
  PEUGEOT: ["1.2 PURETECH", "1.6 HDI", "1.5 BLUEHDI", "1.6 BLUEHDI", "1.6 THP"],
  CITROEN: ["1.2 PURETECH", "1.6 HDI", "1.5 BLUEHDI", "1.6 BLUEHDI"],
  HONDA: ["1.4 I-VTEC", "1.5 VTEC", "1.6 I-DTEC", "1.6 I-VTEC", "1.8 I-VTEC"],
  NISSAN: ["1.2 DIG-T", "1.3 DIG-T", "1.5 DCI", "1.6 DCI", "1.6"],
  SKODA: ["1.0 TSI", "1.2 TSI", "1.4 TSI", "1.6 TDI", "2.0 TDI"],
  BMW: ["1.16I", "1.18I", "1.20I", "3.16I", "3.18I", "3.20I", "3.20D", "5.20D"],
  MERCEDES: ["A180", "A180D", "C180", "C200", "C220D", "E200", "E220D"],
  "MERCEDES-BENZ": ["A180", "A180D", "C180", "C200", "C220D", "E200", "E220D"],
  AUDI: ["1.0 TFSI", "1.4 TFSI", "1.6 TDI", "2.0 TDI", "35 TFSI", "40 TDI"],
};
export function enginesFor(brand) { return mergeU(BRAND_ENGINES[trU(brand)] || [], exBrandVals(brand, "motor")); }

const NOW_YEAR = new Date().getFullYear();
export const YEARS = Array.from({ length: NOW_YEAR - 1989 }, (_, i) => String(NOW_YEAR + 1 - i));

export const FUEL_TYPES = ["Benzin", "Dizel", "LPG", "Benzin + LPG", "Hibrit", "Elektrik", "Diğer"];
export const TRANSMISSIONS = ["Manuel", "Otomatik", "Yarı Otomatik", "Diğer"];
export const COLORS = ["Beyaz", "Siyah", "Gri", "Gümüş", "Füme", "Mavi", "Lacivert", "Kırmızı", "Bordo", "Yeşil", "Sarı", "Turuncu", "Kahverengi", "Bej", "Diğer"];
export const VEHICLE_TYPES = ["Otomobil", "SUV", "Pickup", "Minibüs", "Otobüs", "Kamyon", "Kamyonet", "Motosiklet", "Traktör", "Diğer"];

const TRUCK_BRANDS = ["MERCEDES-BENZ", "VOLVO", "SCANIA", "MAN", "DAF", "IVECO", "FORD", "RENAULT", "ISUZU", "BMC"];
const BUS_BRANDS = ["MERCEDES-BENZ", "MAN", "SETRA", "TEMSA", "OTOKAR", "ISUZU", "FORD", "IVECO", "KARSAN", "BMC", "NEOPLAN"];
const MOTO_BRANDS = ["HONDA", "YAMAHA", "SUZUKI", "KAWASAKI", "KTM", "BMW", "VESPA", "PIAGGIO", "MONDIAL", "BAJAJ"];
const TRACTOR_BRANDS = ["NEW HOLLAND", "JOHN DEERE", "MASSEY FERGUSON", "CASE IH", "FİAT", "TÜMOSAN", "BAŞAK", "VALTRA", "DEUTZ-FAHR", "SAME"];

export function brandsFor(type) {
  if (type === "Kamyon" || type === "Kamyonet") return TRUCK_BRANDS;
  if (type === "Otobüs" || type === "Minibüs") return BUS_BRANDS;
  if (type === "Motosiklet") return MOTO_BRANDS;
  if (type === "Traktör") return TRACTOR_BRANDS;
  if (type === "Diğer") return [];
  return BRANDS;
}

export function modelsForType(brand, type) {
  if (type && type !== "Otomobil" && type !== "SUV" && type !== "Pickup") return [];
  return modelsFor(brand);
}

const TYPE_BODIES = {
  "Otomobil": ["Sedan", "Hatchback", "Station Wagon", "Coupe", "Cabrio", "Diğer"],
  "SUV": ["SUV", "Crossover", "Diğer"],
  "Pickup": ["Tek Kabin", "Çift Kabin", "Diğer"],
  "Minibüs": ["Minibüs", "Midibüs", "Panelvan", "Diğer"],
  "Otobüs": ["Şehir İçi", "Şehirler Arası", "Midibüs", "Diğer"],
  "Kamyon": ["Çekici (Tır)", "Damperli", "Frigorifik", "Tenteli", "Açık Kasa", "Diğer"],
  "Kamyonet": ["Panelvan", "Açık Kasa", "Frigorifik", "Diğer"],
  "Motosiklet": ["Scooter", "Naked", "Sport", "Touring", "Enduro", "Cruiser", "Diğer"],
  "Traktör": ["Tarla", "Bahçe", "Kompakt", "Diğer"],
  "Diğer": ["Diğer"],
};
export function bodiesFor(type) { return TYPE_BODIES[type] || TYPE_BODIES["Otomobil"]; }
export function yearsForModel(brand, model) { const m = exModel(brand, model); return m && m.yil ? YEARS.filter((y) => parseInt(y, 10) >= m.yil) : YEARS; }
export function bodiesForModel(brand, model, type) { const m = exModel(brand, model); return m && m.kasa && m.kasa.length ? m.kasa : bodiesFor(type); }
export function fuelsFor(brand, model) { const m = exModel(brand, model); return m && m.yakit && m.yakit.length ? m.yakit : FUEL_TYPES; }
export function gearsFor(brand, model) { const m = exModel(brand, model); return m && m.sanziman && m.sanziman.length ? m.sanziman : TRANSMISSIONS; }

const slug = (s) => trU(s).toLocaleLowerCase("tr-TR").replace(/ı/g, "i").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
const BRAND_SLUG_FIX = { "volkswagen": "vw", "mercedes-benz": "mercedes" };
const MODEL_IMAGES = new Set(["dacia-duster", "dacia-sandero", "fiat-egea", "ford-focus", "ford-tourneo-courier", "honda-civic", "hyundai-i20", "opel-astra", "peugeot-3008", "renault-clio", "renault-megane", "toyota-corolla", "vw-golf", "vw-passat"]);
const BRAND_IMAGES = new Set(["audi", "bmw", "chery", "citroen", "dacia", "fiat", "ford", "honda", "hyundai", "kia", "mercedes", "mg", "mitsubishi", "nissan", "opel", "peugeot", "renault", "seat", "skoda", "suzuki", "toyota", "volkswagen", "volvo"]);

export function stockImageFor(brand, model) {
  const b = BRAND_SLUG_FIX[slug(brand)] || slug(brand);
  const m = `${b}-${slug(model)}`;
  if (b && m !== b && MODEL_IMAGES.has(m)) return `/car-images/${m}.jpg`;
  if (b && BRAND_IMAGES.has(b)) return `/car-images/brand-${b}.jpg`;
  return "/car-images/generic.jpg";
}

